/**
 * Utilidades para el formateo de números de teléfono
 */

/**
 * Formatea un número de teléfono con el patrón: +XX XXX-XXX-XXXX
 * @param value - Valor actual del campo (solo números)
 * @returns Número de teléfono formateado
 */
export function formatPhoneNumber(value: string): string {
  // Remover todos los caracteres no numéricos
  const numbers = value.replace(/\D/g, "");

  // Si no hay números, retornar vacío
  if (numbers.length === 0) return "";

  // Aplicar formato según la longitud
  if (numbers.length <= 2) {
    return `+${numbers}`;
  } else if (numbers.length <= 5) {
    return `+${numbers.slice(0, 2)} ${numbers.slice(2)}`;
  } else if (numbers.length <= 8) {
    return `+${numbers.slice(0, 2)} ${numbers.slice(2, 5)}-${numbers.slice(5)}`;
  } else if (numbers.length <= 11) {
    return `+${numbers.slice(0, 2)} ${numbers.slice(2, 5)}-${numbers.slice(5, 8)}-${numbers.slice(8)}`;
  } else {
    // Limitar a 12 dígitos máximo
    return `+${numbers.slice(0, 2)} ${numbers.slice(2, 5)}-${numbers.slice(5, 8)}-${numbers.slice(8, 12)}`;
  }
}

/**
 * Desformatea un número de teléfono, removiendo todos los caracteres no numéricos
 * @param value - Valor formateado del campo
 * @returns Solo los números del teléfono
 */
export function unformatPhoneNumber(value: string): string {
  // Remover todos los caracteres no numéricos
  return value.replace(/[^\d+]/g, "");
}

/**
 * Valida si un número de teléfono tiene el formato correcto
 * @param value - Número de teléfono a validar
 * @returns true si el formato es válido
 */
export function isValidPhoneFormat(value: string): boolean {
  const unformatted = unformatPhoneNumber(value);
  // Debe tener entre 7 y 12 dígitos (incluyendo código de país)
  return unformatted.length >= 7 && unformatted.length <= 12;
}

/**
 * Obtiene solo los dígitos de un número de teléfono
 * @param value - Número de teléfono (formateado o no)
 * @returns Solo los dígitos
 */
export function getPhoneDigits(value: string): string {
  return unformatPhoneNumber(value);
}
